import { render, staticRenderFns } from "./importNoticeAdd.vue?vue&type=template&id=2d44e1ef"
import script from "./importNoticeAdd.vue?vue&type=script&lang=js"
export * from "./importNoticeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports